export const DEFAULT_DOCUMENT_TITLE = '클로브AI';
export const DEFAULT_PARTNER_DOCUMENT_TITLE = '자료 전송 간편화 서비스';
